<template>
  <div class="label">
    <label :for="elementId">{{ verbose }}</label>
    <input
      type="text"
      :name="elementId"
      :id="elementId"
      :value="search"
      @input="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
      @keydown.esc="arrowCounter = -1"
      @click="handleInputClick"
      autocomplete="off"
      ref="input"
    />
    <ul class="suggestions" v-show="isOpen">
      <li
        v-for="(item, i) in suggestions"
        :key="item"
        :class="{ 'is-active': i === arrowCounter }"
        @click="setValue(item)"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
import Search from '@/api/search.js'

export default {
  name: 'SuggesterInput',

  props: {
    ressource: String,
    fieldname: String,
    verbose: String,
    value: String,
    selectRequired: Boolean
  },

  data () {
    return {
      suggestions: [],
      triggerSize: 3,
      search: this.value,
      isOpen: false,
      arrowCounter: -1
    }
  },

  methods: {
    onChange: function (event) {
      if (!this.selectRequired || !event.target.value) {
        this.$emit('input', event.target.value)
      }
      this.search = event.target.value

      if (event.target.value.length < this.triggerSize) {
        this.isOpen = false
      } else {
        Search.searchSuggestions(
          this.ressource,
          this.fieldname,
          event.target.value
        ).then((response) => {
          this.suggestions = response
          this.isOpen = Boolean(response.length)
        })
      }
    },

    setValue: function (value) {
      this.search = value
      this.$emit('input', this.search)
      this.suggestions = [this.search]
      this.isOpen = false
      this.arrowCounter = -1
      this.$refs.input.focus()
    },

    clearSearch: function () {
      // this.search = ''
      this.isOpen = false
      this.arrowCounter = -1
    },

    handleClickOutside: function (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
        if (this.selectRequired && !this.isSearchInSuggestions) {
          this.clearSearch()
        }
      }
    },

    handleInputClick: function () {
      if (this.search.length >= this.triggerSize) {
        this.isOpen = true
      }
    },

    // keyboard management
    onArrowDown: function () {
      if (this.arrowCounter < this.suggestions.length - 1) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },

    onArrowUp: function () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },

    onEnter: function () {
      if (this.arrowCounter !== -1) {
        this.setValue(this.suggestions[this.arrowCounter])
      } else {
        this.isOpen = false
        this.arrowCounter = -1
      }
    }
  },

  computed: {
    elementId: function () {
      return this.ressource + this.fieldname
    },

    isSearchInSuggestions () {
      return this.suggestions.includes(this.search)
    }
  },

  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },

  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  },

  watch: {
    value: {
      handler: function (newVal) {
        if (newVal !== this.search) {
          this.search = newVal
        }
      }
    },
    isOpen () {
      this.$emit('update:suggesterState', this.isOpen)
    }
  }
}
</script>
